// Offertenummers in lopende tekst van de assistent herkennen ("eerdere offertes 9675
// (…) en 9572"), zodat je er met één klik in kunt kijken om te vergelijken
// (wiki-feedback Offerte generator, 26 sep). Bewust streng: alleen 4–5-cijferige
// nummers in dezelfde zin ná het woord "offerte(s)"/"offertenummer", en geen
// datums (2026-09-24), verhoudingen (16:9) of bedragen (€ 9500).

const ZIN_EINDE = /[.;!?\n](\s|$)/;

/** Tekst → [{ tekst }] | [{ nummer, tekst }] in volgorde. */
export function splitsOfferteNummers(invoer) {
  const tekst = String(invoer || '');
  const delen = [];
  let rest = 0;
  const trefwoord = /offerte(?:s|nummers?)?\b/gi;
  let m;
  const gezien = [];
  while ((m = trefwoord.exec(tekst))) {
    const start = m.index + m[0].length;
    const na = tekst.slice(start);
    const eind = na.search(ZIN_EINDE);
    const zin = eind === -1 ? na : na.slice(0, eind);
    const num = /\d{4,5}(?!\d)/g;
    let n;
    while ((n = num.exec(zin))) {
      const abs = start + n.index;
      const voor = tekst[abs - 1] || '';
      const na1 = tekst[abs + n[0].length] || '';
      if (/[\d:/€.,-]/.test(voor) || /[-:/,.]\d/.test(tekst.slice(abs + n[0].length, abs + n[0].length + 2)) || /[:-]/.test(na1)) continue;
      if (/€\s*$/.test(tekst.slice(Math.max(0, abs - 3), abs))) continue;
      if (!gezien.some((g) => g.abs === abs)) gezien.push({ abs, nummer: n[0] });
    }
    trefwoord.lastIndex = start + (eind === -1 ? na.length : eind);
  }
  gezien.sort((a, b) => a.abs - b.abs).forEach(({ abs, nummer }) => {
    if (abs > rest) delen.push({ tekst: tekst.slice(rest, abs) });
    delen.push({ nummer, tekst: nummer });
    rest = abs + nummer.length;
  });
  if (rest < tekst.length) delen.push({ tekst: tekst.slice(rest) });
  return delen.length ? delen : [{ tekst }];
}

// Eigen domeinen: nooit als klant-contactpersoon voorstellen.
const EIGEN_DOMEINEN = /@(?:[\w-]+\.)*(?:full-?frame\.nl|narrativelabs\.nl|schrijf-schrijf\.nl)$/i;

/** Externe e-mailadressen uit een geplakte mail, in volgorde, zonder dubbelen. */
export function externeMailadressen(tekst) {
  const gevonden = String(tekst || '').match(/[\w.+-]+@[\w-]+(?:\.[\w-]+)+/g) || [];
  const uit = [];
  gevonden.forEach((a) => {
    const schoon = a.replace(/\.+$/, '').toLowerCase();
    if (!EIGEN_DOMEINEN.test(schoon) && !uit.includes(schoon)) uit.push(schoon);
  });
  return uit;
}
